var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('p',{style:(_vm.labelStyles)},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label)),(_vm.mandatory)?_c('span',{style:(_vm.mandatoryStyles)},[_vm._v("*")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }